export default {"src":"/_next/static/media/Group_42545.735bf3ff.svg","height":78,"width":81};